import { Typography } from '@mui/material';
import styled from 'styled-components';

const SaveStatusContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.gray.light};
`;

const StatusText = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.gray.light};
    font-size: 16px;
  }
`;

export { SaveStatusContainer, StatusText };
